import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { X, Cookie } from "lucide-react";
import { Link } from "react-router-dom";

export function CookieConsentBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setShow(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-3 md:p-4 animate-in slide-in-from-bottom-5 safe-bottom">
      <Card className="max-w-4xl mx-auto bg-background/95 backdrop-blur-sm border-border shadow-lg">
        <div className="p-4 md:p-6">
          <div className="flex items-start gap-3 md:gap-4">
            <Cookie className="h-5 w-5 md:h-6 md:w-6 text-primary flex-shrink-0 mt-0.5 md:mt-1" />
            <div className="flex-1 space-y-2 md:space-y-3">
              <h3 className="font-semibold text-sm md:text-lg">We use cookies</h3>
              <p className="text-xs md:text-sm text-muted-foreground leading-snug md:leading-relaxed">
                We use essential cookies to make our site work. With your consent, we may also use non-essential cookies 
                to improve user experience. By clicking "Accept," you agree to our{" "}
                <Link to="/legal/cookies" className="text-primary hover:underline">
                  Cookie Policy
                </Link>
                .
              </p>
              <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
                <Button onClick={handleAccept} size="sm" className="w-full sm:w-auto">
                  Accept All
                </Button>
                <Button onClick={handleDecline} variant="outline" size="sm" className="w-full sm:w-auto">
                  Decline
                </Button>
                <Link to="/legal/cookies" className="w-full sm:w-auto">
                  <Button variant="ghost" size="sm" className="w-full">
                    Learn More About Cookies
                  </Button>
                </Link>
              </div>
            </div>
            <Button
              variant="ghost"
              size="icon"
              className="flex-shrink-0 h-8 w-8 md:h-10 md:w-10"
              onClick={handleDecline}
              aria-label="Close cookie banner"
            >
              <X className="h-3 w-3 md:h-4 md:w-4" />
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}